import { MenuItem } from "../../models/menu/menu.model";

export const MENU: MenuItem[] = [
  {
    id: 2,
    label: "MENUITEMS.DASHBOARDS.TEXT",
    icon: "bx-home-circle",
    link: "/dashboard",
  },
  // App
  {
    id: 3,
    isLayout: true,
  },
  {
    id: 4,
    label: "MENUITEMS.APPS.TEXT",
    isTitle: true,
    // showOnRoles not required
  },
  {
    id: 5,
    label: "MENUITEMS.LEADS_MANAGEMENT.TEXT",
    icon: "bx-target-lock",
    showOnRoles: ["all"],
    subItems: [
      {
        id: 75,
        label: "MENUITEMS.LEADS_MANAGEMENT.LIST.SELL_RENT",
        link: "/leads/sell-rent",
        showOnRoles: ["all"],
        parentId: 5,
      },
      {
        id: 76,
        label: "MENUITEMS.LEADS_MANAGEMENT.LIST.BUY",
        link: "/leads/buy",
        showOnRoles: ["all"],
        parentId: 5,
      },
      {
        id: 77,
        label: "MENUITEMS.LEADS_MANAGEMENT.LIST.RENT",
        link: "/leads/rent",
        showOnRoles: ["all"],
        parentId: 5,
      },
      {
        id: 78,
        label: "MENUITEMS.LEADS_MANAGEMENT.LIST.COBROKE",
        link: "/cobroke/list/approval",
        queryParams: { is_lead: "true" },
        showOnRoles: ["all"],
        parentId: 5,
      },
    ],
  },
  {
    id: 38,
    label: "MENUITEMS.CONTACTS.TEXT",
    icon: "bxs-user-detail",
    showOnRoles: ["all"],
    subItems: [
      {
        label: "MENUITEMS.CONTACTS.LIST.CONTACT_APPROVAL",
        link: "/contacts/approvals",
        parentId: 38,
      },
      {
        id: 39,
        label: "MENUITEMS.CONTACTS.LIST.CONTACT_LIST",
        link: "/contacts/list",
        showOnRoles: ["all"],
        parentId: 38,
      },
      {
        id: 18,
        label: "MENUITEMS.OWNERS.TEXT",
        link: "/owners/list",
        showOnRoles: ["all"],
        parentId: 38,
      },
      {
        id: 22,
        label: "MENUITEMS.BUYERS.TEXT",
        link: "/buyers/list",
        showOnRoles: ["all"],
        parentId: 38,
      },
      {
        id: 26,
        label: "MENUITEMS.TENANTS.TEXT",
        link: "/tenants/list",
        showOnRoles: ["all"],
        parentId: 38,
      },
      {
        id: 396,
        label: "MENUITEMS.CONTACTS.CATEGORY",
        showOnRoles: ["all"],
        parentId: 38,
        subItems: [
          {
            id: 391,
            label: "MENUITEMS.CONTACTS.LIST.BANKER",
            link: "/contacts/list",
            queryParams: { category: "banker" },
            showOnRoles: ["all"],
            parentId: 396,
          },
          {
            id: 392,
            label: "MENUITEMS.CONTACTS.LIST.LAWYER",
            link: "/contacts/list",
            queryParams: { category: "lawyer" },
            showOnRoles: ["all"],
            parentId: 396,
          },
          {
            id: 393,
            label: "MENUITEMS.CONTACTS.LIST.COBROKE_AGENT",
            link: "/contacts/list",
            queryParams: { category: "cobroke-agent" },
            showOnRoles: ["all"],
            parentId: 396,
          },
          {
            id: 394,
            label: "MENUITEMS.CONTACTS.LIST.MORTGAGE",
            link: "/contacts/list",
            queryParams: { category: "mortgage" },
            showOnRoles: ["all"],
            parentId: 396,
          },
          {
            id: 395,
            label: "MENUITEMS.CONTACTS.LIST.CONTRACTOR",
            link: "/contacts/list",
            queryParams: { category: "contractor" },
            showOnRoles: ["all"],
            parentId: 396,
          },
          {
            id: 30,
            label: "MENUITEMS.EXTERNAL.TEXT",
            link: "/contacts/list",
            queryParams: { category: "external" },
            showOnRoles: ["all"],
            parentId: 396,
          },
        ],
      },
    ],
  },
  // {
  //   id: 10,
  //   label: "MENUITEMS.TEAMS.TEXT",
  //   icon: "bx-group",
  //   showOnRoles: ["all"],
  //   subItems: [
  //     {
  //       id: 11,
  //       label: "MENUITEMS.TEAMS.LIST.TEAM_LIST",
  //       link: "/teams/list",
  //       parentId: 10,
  //     },
  //     {
  //       id: 12,
  //       label: "MENUITEMS.TEAMS.LIST.TEAM_DETAIL",
  //       link: "/teams/detail",
  //       parentId: 10,
  //     },
  //     {
  //       id: 13,
  //       label: "MENUITEMS.TEAMS.LIST.CREATE_TEAM",
  //       link: "/users/create",
  //       parentId: 10,
  //     },
  //   ],
  // },
  {
    id: 14,
    label: "MENUITEMS.PROPERTIES.TEXT",
    icon: "bx-building-house ",
    showOnRoles: ["all"],
    subItems: [
      {
        id: 15,
        label: "MENUITEMS.PROJECTS.TEXT",
        icon: "bx-building-house ",
        showOnRoles: ["all"],
        subItems: [
          {
            id: 16,
            label: "MENUITEMS.PROJECTS.LIST.PROJECT_LIST",
            link: "/projects/list",
            showOnRoles: ["all"],
            parentId: 15,
          },
          {
            id: 17,
            label: "MENUITEMS.PROJECTS.LIST.CREATE_PROJECT",
            link: "/projects/detail",
            showOnRoles: ["superadmin"],
            parentId: 15,
          },
          {
            id: 150,
            label: "MENUITEMS.PROJECTS.LIST.PROJECT_SUBMISSIONS",
            link: "/project-submissions/list",
            showOnRoles: ["all"],
            parentId: 15,
          },
          {
            id: 151,
            label: "MENUITEMS.PROJECTS.LIST.PROJECT_SUBMISSION_APPROVALS",
            link: "/project-submission-approvals/list",
            showOnRoles: ["superadmin"],
            parentId: 15,
          },
          {
            // Slice 2: org Project Settings (state visibility) — Admin,
            // Director and Superadmin only (lowercase role tokens).
            id: 102,
            label: "MENUITEMS.PROJECTS.LIST.PROJECT_SETTINGS",
            link: "/projects/settings",
            showOnRoles: ["admin", "director", "superadmin"],
            parentId: 15,
          },
        ],
      },
      // {
      //   id: 18,
      //   label: "MENUITEMS.PROPERTY_UNIT_TYPES.TEXT",
      //   icon: "bx-building-house ",
      //   showOnRoles: ["all"],
      //   subItems: [
      //     {
      //       id: 19,
      //       label: "MENUITEMS.PROPERTY_UNIT_TYPES.LIST.PROPERTY_UNIT_TYPE_LIST",
      //       link: "/property-unit-types/list",
      //       showOnRoles: ["all"],
      //       parentId: 18,
      //     },
      //     {
      //       id: 20,
      //       label:
      //         "MENUITEMS.PROPERTY_UNIT_TYPES.LIST.CREATE_PROPERTY_UNIT_TYPE",
      //       link: "/property-unit-types/detail",
      //       showOnRoles: ["all"],
      //       parentId: 18,
      //     },
      //   ],
      // },
      {
        id: 21,
        label: "MENUITEMS.PROPERTIES.TEXT",
        icon: "bx-building-house ",
        showOnRoles: ["all"],
        subItems: [
          {
            id: 22,
            label: "MENUITEMS.PROPERTIES.LIST.PROPERTY_LIST",
            link: "/properties/list",
            showOnRoles: ["all"],
            parentId: 21,
          },
          {
            id: 23,
            label: "MENUITEMS.PROPERTIES.LIST.CREATE_PROPERTY",
            link: "/properties/detail",
            showOnRoles: ["all"],
            parentId: 21,
          },
          {
            id: 29,
            label: "MENUITEMS.PROPERTIES.LIST.PROPERTY_SALES",
            link: "/property-sales/list",
            showOnRoles: ["all"],
            parentId: 21,
          },
        ],
      },
    ],
  },
  {
    id: 24,
    label: "MENUITEMS.COBROKE.TEXT",
    icon: "bx-transfer-alt",
    showOnRoles: ["all"],
    subItems: [
      {
        id: 25,
        label: "MENUITEMS.COBROKE.LIST.PROPERTY_LIST",
        link: "/cobroke/properties",
        showOnRoles: ["all"],
        parentId: 24,
      },
      {
        id: 26,
        label: "MENUITEMS.COBROKE.LIST.REQUESTS",
        link: "/cobroke/list/request",
        showOnRoles: ["all"],
        parentId: 24,
      },
      {
        id: 27,
        label: "MENUITEMS.COBROKE.LIST.APPROVAL",
        link: "/cobroke/list/approval",
        showOnRoles: ["all"],
        parentId: 24,
      },
      {
        id: 28,
        label: "MENUITEMS.COBROKE.LIST.ACTIVE",
        link: "/cobroke/list/active",
        showOnRoles: ["all"],
        parentId: 24,
      },
    ],
  },
  {
    id: 34,
    label: "MENUITEMS.APPOINTMENTS.TEXT",
    icon: "bx-calendar-event",
    showOnRoles: ["all"],
    link: "/appointments/list",
    // subItems: [
    //   {
    //     id: 35,
    //     // label: "MENUITEMS.APPOINTMENTS.LIST.APPOINTMENT_LIST",
    //     label: "MENUITEMS.APPOINTMENTS.TEXT",
    //     link: "/appointments/list",
    //     showOnRoles: ["all"],
    //     parentId: 34,
    //   },
    // {
    //   id: 36,
    //   label: "MENUITEMS.APPOINTMENTS.LIST.APPOINTMENT_DETAIL",
    //   link: "/appointments/detail",
    //   showOnRoles: ["all"],
    //   parentId: 34,
    // },
    // {
    //   id: 37,
    //   label: "MENUITEMS.APPOINTMENTS.LIST.CREATE_APPOINTMENT",
    //   link: "/appointments/create",
    //   parentId: 34,
    // },
    // ],
  },
  {
    id: 96,
    label: "MENUITEMS.TIMELINE.TEXT",
    icon: "bx-git-branch",
    showOnRoles: ["all"],
    subItems: [
      {
        id: 97,
        label: "MENUITEMS.TIMELINE.LIST.TIMELINE_LIST",
        link: "/timeline/list",
        showOnRoles: ["all"],
        parentId: 96,
      },
      {
        id: 98,
        label: "MENUITEMS.TIMELINE.LIST.TIMELINE",
        link: "/timeline",
        showOnRoles: ["all"],
        parentId: 96,
      },
      {
        id: 99,
        label: "MENUITEMS.TIMELINE.LIST.TIMELINE_STEP",
        link: "/timeline/step",
        showOnRoles: ["all"],
        parentId: 96,
      },
    ],
  },
  {
    id: 30,
    label: "MENUITEMS.NOTIFICATIONS.TEXT",
    link: "/notifications/list",
    icon: "bx-bell",
    showOnRoles: ["all"],
  },
  // Finance
  {
    id: 42,
    isLayout: true,
  },
  // {
  //   id: 43,
  //   label: "MENUITEMS.FINANCE.TEXT",
  //   isTitle: true,
  //   // showOnRoles not required
  // },
  // {
  //   id: 44,
  //   label: "MENUITEMS.MARKETING_CAMPAIGN.TEXT",
  //   icon: "bx-bar-chart-alt",
  //   showOnRoles: ["all"],
  //   subItems: [
  // {
  //   id: 45,
  //   label: "MENUITEMS.MARKETING_CAMPAIGN.LIST.MARKETING_CAMPAIGN_LIST",
  //   link: "/marketing/list",
  //   showOnRoles: ["all"],
  //   parentId: 44,
  // },
  // {
  //   id: 46,
  //   label: "MENUITEMS.MARKETING_CAMPAIGN.LIST.CREATE_CAMPAIGN",
  //   link: "/marketing/detail",
  //   showOnRoles: ["all"],
  //   parentId: 44,
  // },
  //     {
  //       id: 47,
  //       label: "MENUITEMS.MARKETING_CAMPAIGN.FACEBOOK_POST.TEXT",
  //       link: "/marketing/facebook-post",
  //       parentId: 44,
  //     },
  //   ],
  // },
  // {
  //   id: 48,
  //   label: "MENUITEMS.TRANSACTIONS.TEXT",
  //   icon: "bx-dollar-circle",
  //   showOnRoles: ["all"],
  //   subItems: [
  //     {
  //       id: 49,
  //       label: "MENUITEMS.TRANSACTIONS.LIST.TRANSACTION_LIST",
  //       link: "/transactions/list",
  //       showOnRoles: ["all"],
  //       parentId: 48,
  //     },
  //     {
  //       id: 50,
  //       label: "MENUITEMS.TRANSACTIONS.LIST.TRANSACTION_DETAIL",
  //       link: "/transactions/detail",
  //       showOnRoles: ["all"],
  //       parentId: 48,
  //     },
  // {
  //   id: 51,
  //   label: "MENUITEMS.TRANSACTIONS.LIST.CREATE_TRANSACTION",
  //   link: "/transactions/create",
  //   parentId: 48,
  // },
  //   ],
  // },

  // Setting
  {
    id: 52,
    isLayout: true,
  },
  {
    id: 53,
    label: "MENUITEMS.ADMINISTRATION.TEXT",
    isTitle: true,
    showOnRoles: ["all"],
  },
  {
    id: 54,
    label: "MENUITEMS.ORGANIZATIONS.TEXT",
    icon: "bx-store-alt",
    showOnRoles: ["superadmin", "director", "admin"],
    subItems: [
      {
        id: 55,
        label: "MENUITEMS.ORGANIZATIONS.LIST.ORGANIZATION_LIST",
        link: "/organizations/list",
        showOnRoles: ["superadmin"],
        parentId: 54,
      },
      {
        id: 56,
        label: "MENUITEMS.ORGANIZATIONS.LIST.ORGANIZATION_DETAIL",
        link: "/organizations/detail",
        showOnRoles: ["superadmin", "director", "admin"],
        parentId: 54,
      },
      {
        id: 57,
        label: "MENUITEMS.ORGANIZATIONS.LIST.ORGANIZATION_SETTINGS",
        link: "/organizations/settings",
        showOnRoles: ["superadmin"],
        parentId: 54,
      },
      // {
      //   id: 58,
      //   label: "MENUITEMS.ORGANIZATIONS.LIST.CREATE_ORGANIZATION",
      //   link: "/organizations/create",
      //   parentId: 54,
      // },
    ],
  },
  {
    id: 6,
    label: "MENUITEMS.AGENTS.TEXT",
    icon: "bx-user-circle",
    showOnRoles: ["all"],
    subItems: [
      {
        id: 7,
        label: "MENUITEMS.AGENTS.LIST.AGENT_LIST",
        link: "/agents/list",
        showOnRoles: ["all"],
        parentId: 6,
      },
      {
        id: 8,
        label: "MENUITEMS.AGENTS.LIST.CREATE_AGENT",
        link: "/agents/detail",
        showOnRoles: [
          "superadmin",
          "director",
          "admin",
          "manager",
          "team sales manager",
          "group sales manager",
          "head of branch",
          "assistance manager",
        ],
        parentId: 6,
      },
      {
        id: 61,
        label: "MENUITEMS.AGENTS.LIST.AGENT_GROUPS",
        link: "/agent-groups/list",
        showOnRoles: ["all"],
        parentId: 6,
      },
      {
        id: 62,
        label: "MENUITEMS.AGENTS.LIST.CREATE_AGENT_GROUP",
        link: "/agent-groups/detail",
        showOnRoles: ["superadmin", "director", "admin"],
        parentId: 6,
      },
    ],
  },
  {
    id: 58,
    label: "MENUITEMS.USERS.TEXT",
    icon: "bx-user",
    showOnRoles: ["superadmin", "director", "admin"],
    subItems: [
      {
        id: 59,
        label: "MENUITEMS.USERS.LIST.USER_LIST",
        link: "/users/list",
        showOnRoles: ["superadmin", "director", "admin"],
        parentId: 58,
      },
      {
        id: 60,
        label: "MENUITEMS.USERS.LIST.USER_DETAIL",
        link: "/users/detail",
        showOnRoles: ["superadmin", "director", "admin"],
        parentId: 58,
      },
      // {
      //   id: 61,
      //   label: "MENUITEMS.USERS.LIST.CREATE_USER",
      //   link: "/users/create",
      //   parentId: 58,
      // },
    ],
  },
  {
    id: 62,
    label: "MENUITEMS.ROLES_AND_PERMISSIONS.TEXT",
    icon: "bx-check-shield",
    showOnRoles: ["superadmin"],
    subItems: [
      {
        id: 63,
        label: "MENUITEMS.ROLES_AND_PERMISSIONS.LIST.ROLE_LIST",
        link: "/roles/list",
        showOnRoles: ["superadmin"],
        parentId: 62,
      },
      {
        id: 64,
        label: "MENUITEMS.ROLES_AND_PERMISSIONS.LIST.ROLE_DETAIL",
        link: "/roles/detail",
        showOnRoles: ["superadmin"],
        parentId: 62,
      },
      // {
      //   id: 65,
      //   label: "MENUITEMS.ROLES_AND_PERMISSIONS.LIST.CREATE_ROLE",
      //   link: "/roles/create",
      //   parentId: 62,
      // },
      {
        id: 66,
        label: "MENUITEMS.ROLES_AND_PERMISSIONS.LIST.PERMISSION_LIST",
        link: "/permissions/list",
        showOnRoles: ["superadmin"],
        parentId: 62,
      },
      // {
      //   id: 67,
      //   label: "MENUITEMS.ROLES_AND_PERMISSIONS.LIST.PERMISSION_DETAIL",
      //   link: "/permissions/detail",
      //   parentId: 62,
      // },
      // {
      //   id: 68,
      //   label: "MENUITEMS.ROLES_AND_PERMISSIONS.LIST.CREATE_PERMISSION",
      //   link: "/permissions/create",
      //   parentId: 62,
      // },
    ],
  },
  {
    id: 69,
    label: "MENUITEMS.CHAT.TEXT",
    icon: "bx-conversation",
    showOnRoles: ["superadmin"],
    subItems: [
      {
        id: 70,
        label: "MENUITEMS.CHAT.TEXT",
        link: "/chats/list",
        parentId: 69,
      },
    ],
  },
  {
    id: 71,
    label: "MENUITEMS.CALCULATOR.TEXT",
    icon: "bx-calculator",
    showOnRoles: ["all"],
    subItems: [
      {
        id: 75,
        label: "MENUITEMS.CALCULATOR.LIST_PAGE",
        link: "/calculator/list",
        showOnRoles: ["all"],
        parentId: 71,
      },
      {
        id: 72,
        label: "MENUITEMS.CALCULATOR.LIST.OWNER",
        link: "/calculator/owner",
        showOnRoles: ["all"],
        parentId: 71,
      },
      {
        id: 73,
        label: "MENUITEMS.CALCULATOR.LIST.BUYER",
        link: "/calculator/buyer",
        showOnRoles: ["all"],
        parentId: 71,
      },
      {
        id: 74,
        label: "MENUITEMS.CALCULATOR.LIST.TENANT",
        link: "/calculator/tenant",
        showOnRoles: ["all"],
        parentId: 71,
      },
    ],
  },
  {
    id: 84,
    label: "MENUITEMS.DOCUMENT.TEXT",
    icon: "bx-file",
    showOnRoles: ["all"],
    subItems: [
      {
        id: 94,
        label: "MENUITEMS.DOCUMENT.LIST.SETTINGS",
        link: "/documents/settings",
        showOnRoles: ["all"],
        parentId: 84,
      },
      {
        id: 100,
        label: "MENUITEMS.DOCUMENT.LIST.DOCUMENT_LIST",
        link: "/documents/list",
        showOnRoles: ["all"],
        parentId: 84,
      },
      {
        id: 85,
        label: "MENUITEMS.DOCUMENT.LIST.CREATE_DOCUMENT",
        link: "/documents/detail",
        showOnRoles: ["all"],
        parentId: 84,
      },
      {
        id: 101,
        label: "MENUITEMS.DOCUMENT.CATEGORY",
        showOnRoles: ["all"],
        parentId: 84,
        subItems: [
          {
            id: 86,
            label: "MENUITEMS.DOCUMENT.LIST.GENERAL_ATS",
            link: "/documents/list",
            queryParams: { category: "general-ats" },
            showOnRoles: ["all"],
            parentId: 101,
          },
          {
            id: 87,
            label: "MENUITEMS.DOCUMENT.LIST.EXCLUSIVE_ATS",
            link: "/documents/list",
            queryParams: { category: "exclusive-ats" },
            showOnRoles: ["all"],
            parentId: 101,
          },
          {
            id: 88,
            label: "MENUITEMS.DOCUMENT.LIST.AGREEMENT_TO_PURCHASE",
            link: "/documents/list",
            queryParams: { category: "agreement-to-purchase" },
            showOnRoles: ["all"],
            parentId: 101,
          },
          {
            id: 89,
            label: "MENUITEMS.DOCUMENT.LIST.GENERAL_ATR",
            link: "/documents/list",
            queryParams: { category: "general-atr" },
            showOnRoles: ["all"],
            parentId: 101,
          },
          {
            id: 90,
            label: "MENUITEMS.DOCUMENT.LIST.EXCLUSIVE_ATR",
            link: "/documents/list",
            queryParams: { category: "exclusive-atr" },
            showOnRoles: ["all"],
            parentId: 101,
          },
          {
            id: 94,
            label: "MENUITEMS.DOCUMENT.LIST.GENERAL_ATL",
            link: "/documents/list",
            queryParams: { category: "general-atl" },
            showOnRoles: ["all"],
            parentId: 101,
          },
          {
            id: 91,
            label: "MENUITEMS.DOCUMENT.LIST.AGREEMENT_TO_RENT",
            link: "/documents/list",
            queryParams: { category: "agreement-to-rent" },
            showOnRoles: ["all"],
            parentId: 101,
          },
          {
            id: 92,
            label: "MENUITEMS.DOCUMENT.LIST.TENANCY_AGREEMENT",
            link: "/documents/list",
            queryParams: { category: "tenancy-agreement" },
            showOnRoles: ["all"],
            parentId: 101,
          },
          {
            id: 93,
            label: "MENUITEMS.DOCUMENT.LIST.DUMMY_ATP",
            link: "/documents/list",
            queryParams: { category: "dummy-atp" },
            showOnRoles: ["all"],
            parentId: 101,
          }
        ],
      },
    ],
  },
  {
    id: 93,
    label: "MENUITEMS.ASK_APRO.TEXT",
    icon: "bx-bot",
    showOnRoles: ["all"],
    subItems: [
      {
        id: 94,
        label: "MENUITEMS.ASK_APRO.LIST.ASK_APRO",
        link: "/ask-apro",
        showOnRoles: ["all"],
        parentId: 93,
      },
      {
        id: 95,
        label: "MENUITEMS.ASK_APRO.LIST.PROPERTY_INFORMATION",
        link: "/ask-apro/property-information",
        showOnRoles: ["all"],
        parentId: 93,
      },
    ],
  },
  {
    id: 97,
    label: "MENUITEMS.GUIDELINE.TEXT",
    icon: "bx-book-open",
    link: "/guideline",
    showOnRoles: ["all"],
  },
];
